/**
 * Loading the admin-defined `/` kinds (F-17-type) — the NETWORK half of
 * features/text-kinds, deliberately split from ./store.ts.
 *
 * The split is load-bearing, not tidiness: `core/api.ts` reads
 * `import.meta.env` (a Vite-only global), and the server's e2e harnesses
 * typecheck the client's `GridTable` module for its `GridLayoutSnapshot`
 * type — so anything that module imports has to compile in a plain Node
 * program too. The editors import the store; only the app shell, a board
 * open and the admin page import this.
 */
import { fetchTextKinds } from "../../core/api.js";

import { textKinds } from "./store.js";

let inflight: Promise<void> | null = null;

/**
 * (Re)load the registry. Coalesces concurrent callers — the app shell and a
 * board opening at the same moment must not issue two requests — and never
 * throws: a failed load keeps whatever the store already holds (an empty list
 * on first load, which renders exactly like "no custom kinds").
 */
export function loadTextKinds(): Promise<void> {
  if (inflight !== null) return inflight;
  inflight = fetchTextKinds()
    .then((response) => textKinds.getState().setKinds(response.kinds))
    .catch(() => {
      /* keep what we have; the next open retries */
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}
